/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {getTreeAssetLoaderKey} from '@ion/dls/src/utils/Keys';
import {loadGroupAssets} from '@/store/actions/groups-filter';

/**
 *
 * React Hook to provide util functions for loading asset in the Tree.
 *
 *  ```typescript
 *
 *   import {useLoadGroupAssets} from '../../hooks/';
 *
 *   const onLoadGroupAssets = useLoadGroupAssets();
 *
 *  ```
 */
export const useLoadGroupAssets = () => {
  const dispatch = useDispatch();

  const onLoadGroupAssets = useCallback(({node}) => {
    const {isLoader, groupId, key} = node || {};
    if (isLoader) {
      dispatch(loadGroupAssets(groupId, getTreeAssetLoaderKey(key)));
    }
  }, []);

  return onLoadGroupAssets;
};
